import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { Layout, SEO, Breadcrumbs } from '../../components';
import { isValidArray } from '../../components/utilities/validations';
import { filterContentByTags } from '../../components/utilities/functions';

import LocalNavTop from '../../components/common/local-nav-top';
import ProjectsHero from '../../components/common/projects-hero';
import CardSection from '../../components/common/card-section';
import RTAShowroomPanel from '../../components/template/homepage/rta-showroom-panel';
import ProjectCarousel from '../../components/template/branch-project-listing/project-carousel';
import ProjectGallery from '../../components/template/branch-project-listing/project-gallery';

const ProjectListing = (props) => {
	const pageData = props.data.contentstackProjectListing;
	const { nodes } = props.data.branchProjects;

	return (
		<Layout
			id='template-ProjectListing'
			hideLeadGen
		>
			{isValidArray(pageData?.branch_data?.[0]?.local_nav) && (
				<LocalNavTop
					branchData={pageData?.branch_data?.[0]}
					linksArray={pageData?.branch_data?.[0].local_nav}
					isAnchors={false}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.breadcrumbs && (
				<Breadcrumbs
					data={pageData.breadcrumbs}
					currentUrl={pageData.url}
				/>
			)}

			{pageData.hero && <ProjectsHero data={pageData.hero} />}

			{isValidArray(pageData.page_components) &&
				pageData.page_components.map((block, index) => {
					if (block.cards != null) {
						return (
							<CardSection
								key={index}
								data={block.cards}
							/>
						);
					}

					if (block.gallery != null) {
						return (
							<ProjectGallery
								key={index}
								projects={nodes}
								data={block.gallery}
							/>
						);
					}

					if (block.rta != null) {
						return (
							<RTAShowroomPanel
								data={block.rta}
								key={index}
							/>
						);
					}

					if (block.carousel != null && isValidArray(nodes)) {
						let articlesByTags = block.carousel.manual || [];
						if (isValidArray(block.carousel.filter_tags)) articlesByTags = filterContentByTags(block.carousel.filter_tags, nodes, false);

						return (
							<ProjectCarousel
								key={index}
								data={block.carousel}
								projects={articlesByTags?.slice(0, 6)}
								style={block.carousel.background_hex_value ? { backgroundColor: block.carousel.background_hex_value } : null}
							/>
						);
					}
				})}
		</Layout>
	);
};

ProjectListing.propTypes = {
	data: PropTypes.object,
	location: PropTypes.object,
};

export default ProjectListing;

// eslint-disable-next-line react/prop-types -- gatsby head component
export const Head = ({ data }) => <SEO {...data.contentstackProjectListing.seo} />;

export const query = graphql`
	query ($uid: String!, $branch_id: [String]) {
		contentstackProjectListing(id: { eq: $uid }) {
			url
			breadcrumbs {
				...Breadcrumbs
			}
			branch_data {
				...BranchData
			}
			branch_id
			hero {
				description
				heading
				cta {
					...CTA
				}
				image {
					...Image
					image {
						url
						gatsbyImageData(quality: 90)
					}
				}
			}
			page_components {
				cards {
					...CardSection
				}
				carousel {
					background_hex_value
					heading
					filter_tags
					manual {
						...Article
					}
					cta {
						...CTA
					}
				}
				gallery {
					heading
					filter_tag {
						display_name
						filter_tags
					}
				}
				rta {
					heading
				}
			}
			seo {
				...SEO
			}
		}
		branchProjects: allContentstackArticles(filter: { branch_data: { elemMatch: { branch_retail: { in: $branch_id } } }, taxonomies: { elemMatch: { term_uid: { eq: "branch_project" } } } }, sort: { created_at: DESC }) {
			nodes {
				...Article
			}
		}
	}
`;
